import Address from './Address';
import PhoneNumber from './PhoneNumber';

export default class ClientContact {
    id?: number;
    number?: number;
    lastName?: string;
    firstName?: string;
    address?: Address;
    title?: string;
    salutation?: string;
    primaryContact?: boolean;
    phone?: PhoneNumber;
    cme?: boolean;
    email?: string;
    userName?: string;
    accountStatus?: string;
    dashBoard?: boolean;
    clientNumber?: number;
    employeeNumber?: number;
    city?: string;
    state?: string;
    zipCode?: number;
    homePhone?: string;
    fax?: string;
    emailAddress?: string;
    officeEmailAddress?: string;
    officePhone?: string;
    officeExt?: string;
    cellPhone?: string;
    secName?: string;
    secPhone?: string;
    active?: boolean;
    whereNow?: string;
    notes?: string;
    address2?: string;
    password?: string;
    certifications?: string;
    homeAddress?: string;
    homeAddress2?: string;
    homeCity?: string;
    homeState?: string;
    homeZipCode?: string;
}



// WEBPACK FOOTER //
// ./src/models/ClientContact.ts